import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/guide/subscribeManage/step-1.png'
import _imports_1 from '@/assets/img/guide/subscribeManage/step-2.png'
import _imports_2 from '@/assets/img/guide/subscribeManage/step-3.png'
import _imports_3 from '@/assets/img/guide/subscribeManage/step-4.png'
import _imports_4 from '@/assets/img/guide/subscribeManage/step-5.png'
import _imports_5 from '@/assets/img/guide/subscribeManage/step-6.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-0040500a")

_pushScopeId("data-v-0040500a")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { id: "guide-help" }
const _hoisted_3 = {
  key: 0,
  class: "guideFollow"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("p", null, "1. 进入微信主页，点击红框圈住的这个图标；", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("p", null, "2. 在输入框中输入“数本健康”，选择下方出现的结果；", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("p", null, "3. 点击红框圈住的页面，进入数本健康公众号；", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("img", { src: _imports_2 }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("p", null, "4. 进入公众号后，点击关注公众号；", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("img", { src: _imports_3 }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("p", null, "5. 最后点击下方按钮开始重新检测。", -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode("重新检测")
const _hoisted_14 = {
  key: 1,
  class: "guideMessageBind"
}
const _hoisted_15 = /*#__PURE__*/_createVNode("p", null, "1. 在数本健康公众号底部，点击“通知绑定”；", -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("img", { src: _imports_4 }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("p", null, "2. 在数本健康公众号收到该信息，视为通知绑定成功；", -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("img", { src: _imports_5 }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("p", null, "3. 最后点击下方按钮开始重新检测。", -1)
const _hoisted_20 = /*#__PURE__*/_createTextVNode("重新检测")
const _hoisted_21 = /*#__PURE__*/_createVNode("div", {
  "safe-area-inset-bottom": "",
  style: {"padding-bottom":"2em"}
}, null, -1)
const _hoisted_22 = { class: "wrapper" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" 检测状态中... ")
const _hoisted_24 = { class: "subscribe-manage-list-box" }
const _hoisted_25 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_26 = { class: "van-ellipsis" }
const _hoisted_27 = { class: "flex-center-center" }
const _hoisted_28 = /*#__PURE__*/_createTextVNode("订阅管理")
const _hoisted_29 = {
  key: 1,
  class: "subscribe-manage-state-box"
}
const _hoisted_30 = { class: "wrapper" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_van_button = _resolveComponent("van-button")
  const _component_van_loading = _resolveComponent("van-loading")
  const _component_van_overlay = _resolveComponent("van-overlay")
  const _component_van_image = _resolveComponent("van-image")
  const _component_van_col = _resolveComponent("van-col")
  const _component_van_row = _resolveComponent("van-row")
  const _component_van_badge = _resolveComponent("van-badge")
  const _component_van_cell = _resolveComponent("van-cell")
  const _component_van_list = _resolveComponent("van-list")
  const _component_van_empty = _resolveComponent("van-empty")
  const _component_van_switch = _resolveComponent("van-switch")
  const _component_van_cell_group = _resolveComponent("van-cell-group")
  const _component_van_action_sheet = _resolveComponent("van-action-sheet")
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")

  return (_ctx.showGuideHelp)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          (_ctx.guideHelpIndex === 0)
            ? (_openBlock(), _createBlock("div", _hoisted_3, [
                _hoisted_4,
                _hoisted_5,
                _hoisted_6,
                _hoisted_7,
                _hoisted_8,
                _hoisted_9,
                _hoisted_10,
                _hoisted_11,
                _hoisted_12,
                _createVNode(_component_van_button, {
                  onClick: _ctx.onRefresh,
                  type: "primary",
                  color: "rgb(159, 102, 204)",
                  size: "normal",
                  block: ""
                }, {
                  default: _withId(() => [
                    _hoisted_13
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]))
            : (_ctx.guideHelpIndex === 1)
              ? (_openBlock(), _createBlock("div", _hoisted_14, [
                  _hoisted_15,
                  _hoisted_16,
                  _hoisted_17,
                  _hoisted_18,
                  _hoisted_19,
                  _createVNode(_component_van_button, {
                    onClick: _ctx.onRefresh,
                    type: "primary",
                    color: "rgb(159, 102, 204)",
                    size: "normal",
                    block: ""
                  }, {
                    default: _withId(() => [
                      _hoisted_20
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]))
              : _createCommentVNode("", true),
          _hoisted_21
        ]),
        _createVNode(_component_van_overlay, { show: _ctx.showGuideHelpLoading }, {
          default: _withId(() => [
            _createVNode("div", _hoisted_22, [
              _createVNode(_component_van_loading, { color: "#0094ff" }, {
                default: _withId(() => [
                  _hoisted_23
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["show"])
      ]))
    : (_openBlock(), _createBlock(_component_van_pull_refresh, {
        key: 1,
        modelValue: _ctx.pageState.loading,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.pageState.loading = $event)),
        onRefresh: _ctx.onRefresh,
        style: {"min-height":"100vh"}
      }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_24, [
            _createVNode(_component_van_list, {
              loading: _ctx.loadState.loading,
              "onUpdate:loading": _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadState.loading = $event)),
              finished: _ctx.loadState.finished,
              "finished-text": "没有更多了",
              onLoad: _ctx.onLoad
            }, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item) => {
                  return (_openBlock(), _createBlock(_component_van_cell, {
                    key: item,
                    "data-member-id": item.memberId,
                    onClick: ($event: any) => (_ctx.openMemberSubscribeManage(item))
                  }, {
                    icon: _withId(() => [
                      _createVNode("div", _hoisted_25, [
                        _createVNode(_component_van_image, {
                          round: "",
                          class: "member-avatar",
                          src: item.memberAvatar || _ctx.defaultAvatar
                        }, null, 8, ["src"])
                      ])
                    ]),
                    title: _withId(() => [
                      _createVNode(_component_van_row, null, {
                        default: _withId(() => [
                          _createVNode(_component_van_col, {
                            span: "16",
                            offset: "1"
                          }, {
                            default: _withId(() => [
                              _createVNode("p", _hoisted_26, _toDisplayString(item.memberName), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    extra: _withId(() => [
                      _createVNode(_component_van_row, null, {
                        default: _withId(() => [
                          _createVNode(_component_van_col, { span: "24" }, {
                            default: _withId(() => [
                              _createVNode("div", _hoisted_27, [
                                _createVNode(_component_van_badge, {
                                  content: item.subscribeCount,
                                  color: "#FAAB0C",
                                  "show-zero": false
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_van_button, {
                                      type: "success",
                                      size: "small",
                                      color: "rgb(159, 102, 204)"
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_28
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 2
                                }, 1032, ["content"])
                              ])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["data-member-id", "onClick"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["loading", "finished", "onLoad"])
          ]),
          _createVNode(_component_van_action_sheet, {
            show: _ctx.subscribeData.show,
            "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => (_ctx.subscribeData.show = $event)),
            title: "订阅状态"
          }, {
            default: _withId(() => [
              (_ctx.subscribeData.list.length === 0)
                ? (_openBlock(), _createBlock(_component_van_empty, {
                    key: 0,
                    description: "无数据列表"
                  }))
                : (_openBlock(), _createBlock("div", _hoisted_29, [
                    _createVNode(_component_van_cell_group, null, {
                      default: _withId(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.subscribeData.list, (item, index) => {
                          return (_openBlock(), _createBlock(_component_van_cell, { key: index }, {
                            title: _withId(() => [
                              _createVNode(_component_van_row, null, {
                                default: _withId(() => [
                                  _createVNode(_component_van_col, { span: "20" }, {
                                    default: _withId(() => [
                                      _createTextVNode(_toDisplayString(item.templateName), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            extra: _withId(() => [
                              _createVNode(_component_van_switch, {
                                modelValue: item.subscribeState,
                                "onUpdate:modelValue": ($event: any) => (item.subscribeState = $event),
                                size: "22px",
                                onChange: ($event: any) => (_ctx.handlerSubscribeStateChange(item)),
                                "active-value": 1,
                                "inactive-value": 2
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]))
            ]),
            _: 1
          }, 8, ["show"]),
          _createVNode(_component_van_overlay, {
            show: _ctx.pageState.overlayState.show
          }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_30, [
                _createVNode(_component_van_loading, { color: "#1989fa" })
              ])
            ]),
            _: 1
          }, 8, ["show"])
        ]),
        _: 1
      }, 8, ["modelValue", "onRefresh"]))
})